module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }), _c('p', {
    staticClass: "CustomHead2",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("ONE")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("Sitting upon a bough, the raven watched.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("In the dying of the light the little boy swung slowly from the tree, his body broken, a noose around his neck. And at the edge of the forest a car burned and the raven watched as flame rose from the heat like hate rising from the heart of the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The raven and the boy were together as the fire burned and burned and began to fade in the last of the day but still the raven did not move. It stayed upon the bough and did not leave the boy alone until the sun had descended and was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The raven watched as the boy was claimed by the darkness of the night. It watched as the fire smoldered and the smoke vanished in the evening gray that overcame the day. It watched and it watched and it watched and it watched until something else had begun to burn in the dying of the light …")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Fire rose in the raven’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "Divider"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Joe Mac felt the gray November cold more completely than he’d ever felt it before because he could no longer see the leaves fade from rust to gold or gaze upon the skeletal silhouettes of trees etched against the gray November sky.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Now he lived in the world of the blind, so feeling the cold was all that remained. The rest was darkness and he would inhabit this darkness until the day he died and they buried him in the dirt and this darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The raven came as it always came; it descended with the sound of enormous wings to land with a thunderclap on the home Joe Mac had built for it.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Three years ago they met as Joe Mac was first learning to live in the world of the blind. The raven had come to him every day as he sat alone in the back of the barn, and Joe Mac named him “Poe” after the old poem. And every evening they would sit together in the back of the barn in Joe Mac’s eternal night. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Poe did not rise or even seem to notice the familiar Mrs. Clemens as she approached, but then Poe rarely flew away when someone came close. Rather, he seemed to know the exact distance for danger and ignored anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Mrs. Clemens brought Joe Mac his supper – an act Joe Mac reckoned to her uncommon human kindness – and spent a moment to inquire about his health. But Joe Mac sensed something different in Mrs. Clemens tonight. Her steps were halting and seemed to wander before she laid a hand on his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Lifting his face, Joe Mac asked, “What is it, Mrs. Clemens?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Mrs. Clemens shuffled, and Joe Mac felt the strength lessen in the hand; it was not much of a change, it was true, but a hand with little strength is even more revealing when what little strength it possesses is diminished ever more.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Joe Mac repeated more sternly, “What is it, Mrs. Clemens?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Oh,” moaned Mrs. Clemens, “it’s horrible, Mr. Joe Mac. Just horrible. Oh, god, I don’t know how to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Just say it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("She faltered, “It’s about your grandson, Mr. Joe Mac. It’s about Aaron. The poor thing disappeared from daycare today.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Joe Mac’s left hand tightened on the arm of the chair. “How could they lose a four-year-old boy? Have they called the police?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Your poor daughter has called everyone! We’re all scared to death something terrible has happened!”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("With a shrill cry Poe erupted into the night sky as Joe Mac stood pulling his wool coat more tightly across his chest; he snapped his cane to length. “Why didn’t someone tell me about this earlier?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“They’ve been too busy searching for him, Mr. Joe Mac! They’ve looked everywhere! And you can’t even …”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("She let the sentence die.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Take me to my daughter,” said Joe Mac. “And compose yourself, Mrs. Clemens. We don’t know that anything terrible has happened. Compose yourself! Stay calm. And take me to my daughter.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0